<template>
  <div class="text-center">
    <img :src="logoSrc" alt="Cryptocurrency Logo" class="mx-auto w-16 h-16 mb-2 rounded-md" />
    <h1 class="text-2xl font-bold text-white my-3">
      <span v-if="historicalPrice">
        $<NumberCounter :number="historicalPrice" :size="24" punctuation />
      </span>
      <span v-else>
        $<NumberCounter :number="currentPrice" :size="24" punctuation />
      </span>
    </h1>
  </div>
</template>

<script>
import NumberCounter from '@/components/NumberCounter.vue';

export default {
  props: {
    logoSrc: {
      type: String,
      required: true,
    },
    historicalPrice: {
      type: [Number, String],
      default: null,
    },
    currentPrice: {
      type: Number,
      required: true,
    },
    displayDate: {
      type: String,
      required: true,
    },
  },
  components: {
    NumberCounter,
  },
};
</script>
